import AppLayout from "../layouts/AppLayout.jsx";
import AccountPersonalInformation from "../components/AccountPersonalInformation.jsx";
import AccountChangePassword from "../components/AccountChangePassword.jsx";
import AccountSocialMedia from "../components/AccountSocialMedia.jsx";
import AccountSubscriptions from "../components/AccountSubscriptions.jsx";
import AccountProfileImage from "../components/AccountProfileImage.jsx";

export default function Account() {
  return (
    <AppLayout currentPage="account">
      <h2 className="fs-4 fw-700 mb-4">Account Settings</h2>

      <AccountProfileImage />

      <section className="mt-3">
            <AccountPersonalInformation />
      </section>

      <section className="mt-3">
        <AccountChangePassword />
      </section>

      <section className="mt-3">
        <AccountSocialMedia />
      </section>

      <section className="mt-3 mb-5">
        <AccountSubscriptions />
      </section>
    </AppLayout>
  );
}
